import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './IcoMoon.styles'

const IcoMoon = ({ icon, size = 18, disableFill, ...props }) => {
  if (size) {
    props.width = size
    props.height = size
  }

  const { width = 1024 } = icon

  props.viewBox = `0 0 ${ width } 1024`

  const paths = icon.paths.map((path, index) =>
    React.createElement('path', {
      d: path,
      key: icon + index,
      ...(!disableFill ? icon.attrs[index] : {}),
    })
  )

  return <Styled.Svg { ...props }>{paths}</Styled.Svg>
}

IcoMoon.propTypes = {
  icon: PropTypes.shape({
    paths: PropTypes.arrayOf(PropTypes.string),
    attrs: PropTypes.arrayOf(PropTypes.string),
  }),
  size: PropTypes.number,
  disableFill: PropTypes.bool,
}

export default IcoMoon
